const actions = {
// export default {
  login: 'login',
  logout: 'login',
  setForm: 'set-form',
}

export default actions
